export default __webpack_public_path__ + "static/media/Group -106@2x.d283d86c.png";